import React, { useEffect, useRef } from 'react'
// The splash is a flipbook: 21 frames stacked by scripts/build-bonus-overlay-strip.py
// from the machine's own atlas (art-source/spriteBonusOverlay@2x.png) — ten that carry
// scale and rotation for the entry, then eleven that cool the word from yellow to cyan
// and crack the letters one by one. Nothing here transforms it; see BonusOverlay.css.
//
// It is imported rather than pointed at in public/ because that layout changes whenever
// the animation is re-derived, and public/ ships every asset under its own unhashed
// name: a browser or CDN still holding the previous sheet pairs it with the new CSS,
// which then smears all 21 frames across the one cell it expects to see. Through the
// bundler the URL carries a content hash, so a changed sheet cannot arrive as the old one.
import BONUS_STRIP from '../../assets/spriteBonusOverlay_strip.png'
import { getAudioVolume } from '../../utils/CookiesUtils'
import './BonusOverlay.css'

const TOTAL_TIME = 9100 // matches entrada_bonus.wav (9.12s) — the bonus opens when the sound ends

// The splash does not appear with the sound: in bonus-ani.mp4 it pops in 1.25s
// after entrada_bonus starts and then holds until the sound runs out. That lead-in
// and the frame timing live in BonusOverlay.css, with the measurements behind them.

// "BÔNUS" splash — swings in from the centre, growing, then settles level and
// cools from yellow to cyan; timed and sized off the reference recording
function BonusOverlay({ onComplete }) {
    // keep the latest callback in a ref so parent re-renders don't reset the timer
    const cbRef = useRef(onComplete)
    cbRef.current = onComplete

    useEffect(() => {
        // the sound starts here; the splash itself is 1.25s behind it (CSS delay)
        const sfx = new Audio('assets/ice-bonus/entrada_bonus.wav')
        sfx.volume = getAudioVolume()
        sfx.play().catch(() => { })

        const t = setTimeout(() => cbRef.current && cbRef.current(), TOTAL_TIME)
        return () => {
            clearTimeout(t)
            sfx.pause()
            sfx.currentTime = 0
        }
    }, [])

    return (
        <div className='bonus-overlay'>
            <div
                className='bonus-overlay-art'
                style={{ backgroundImage: `url(${BONUS_STRIP})` }}
            />
        </div>
    )
}

export default BonusOverlay
